import React from 'react'
import { Button } from '@headlessui/react'
import { formatDate } from 'utils/helpers'
import TruncatedText from '../TruncatedTextPopover'


export type Deal = {
  id: string
  /** Human-readable reference (e.g. "D002") — what the deal URL is built from. */
  dealKey?: string
  name: string
  amount: string
  stage: string
  closeDate: string
}

function DealCard({ deal, onClick }: { deal: Deal; onClick?: () => void }) {

  return (
    <Button
      onClick={onClick}
      className="w-full cursor-pointer rounded-xl border border-primary-subtle bg-primary-light p-3 text-left transition-colors duration-150 hover:border-neutral-medium/40 hover:bg-primary-variant focus:outline-none focus-visible:border-neutral-medium/40 active:opacity-70"
    >
      <div className="text-[15px] font-semibold capitalize ">{deal.name}</div>
      <div className="mt-1 text-[15px] font-bold text-emphasis">{deal.amount}</div>
      {/* <div className="mt-1.5 text-[13px] text-neutral-faded">
        {deal.stage} {deal.stage && deal.closeDate && '·' } closes {formatDate(deal.closeDate, '—')}
      </div> */}
      <div className="mt-1.5 flex items-center gap-1 text-[13px] text-neutral-faded">
        {deal.stage && <TruncatedText text={deal.stage} className="min-w-0" />}
        {deal.stage && deal.closeDate && <span className="shrink-0">·</span>}
        {deal.closeDate && (
          <span className="shrink-0 whitespace-nowrap text-xs">
            closes {formatDate(deal.closeDate)}
          </span>
        )}
      </div>
    </Button>
  )
}


export default DealCard